import { dateAsNumber } from "@nova/serializer/src/client/util"
import store from "integrations/redux/store"
import { selectUserID } from "user/profile/selectors"

export const updateIntegrationMetadata = (existing: string | undefined, integrationKey: string) => {
    const state = store.getState()
    const userId = selectUserID(state)
    if (userId) {
        const integrations = !!existing ? JSON.parse(existing) : {}

        integrations[integrationKey] = {
            updatedAt: dateAsNumber(),
            updatedBy: {
                userId,
            },
        }

        const newIntegrationsString = JSON.stringify(integrations)

        return newIntegrationsString
    }
}
